import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { useRef, useCallback, useEffect } from 'react';
import { useStyles, useToken, StyleSheet, StylesProvider } from '@rexlabs/styling';
import Tether from '@rexlabs/tether';
import { useDownshiftContext, safeGetId } from '../../core';
import BaseSelectCore from './components/core';
import BaseMultiSelectCore from './components/multi-core';
import BaseSelectInput from './components/input';
import SingleTypeSelectMenu from './components/single-type/menu';
import MultiTypeSelectMenu from './components/multi-type/menu';
import { get } from 'lodash';

var NullComponent = function NullComponent() {
  return null;
}; // Can't use 'rem' so can't use spacing tokens


var menuDistance = 8; // HACK: "forcing" the tethered menu to be on the top here, ideally we find
// a good and generic zIndex logic instead of hard coded values at some point :/

var overrides = {
  Tether: StyleSheet({
    wrapContent: {
      zIndex: 9000
    }
  })
};
var defaultStyles = StyleSheet({
  root: {
    position: 'relative'
  }
});

function TetherContent(_ref) {
  var children = _ref.children,
      scheduleUpdate = _ref.scheduleUpdate;

  var _useDownshiftContext = useDownshiftContext(),
      selectedItem = _useDownshiftContext.selectedItem;

  useEffect(function () {
    scheduleUpdate();
  }, [selectedItem, scheduleUpdate]);
  return children;
}

function SingleSelectInner(_ref2) {
  var _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? 'unknown' : _ref2$name,
      props = _objectWithoutProperties(_ref2, ["name"]);

  var s = useStyles(defaultStyles, 'SingleSelectInner');
  var token = useToken();
  var container = useRef(null);

  var _useDownshiftContext2 = useDownshiftContext(),
      items = _useDownshiftContext2.items,
      getRootProps = _useDownshiftContext2.getRootProps,
      isOpen = _useDownshiftContext2.isOpen;

  var itemsHaveType = React.useMemo(function () {
    return _someInstanceProperty(items).call(items, function (item) {
      return item.type;
    });
  }, [items]);
  var Content = useCallback(function (contentProps) {
    var _container$current, _container$current2;

    return /*#__PURE__*/React.createElement(TetherContent, contentProps, itemsHaveType ? /*#__PURE__*/React.createElement(MultiTypeSelectMenu, _extends({}, props, {
      // TODO: Fix type
      // eslint-disable-next-line
      // @ts-ignore
      name: name,
      width: (_container$current = container.current) === null || _container$current === void 0 ? void 0 : _container$current.clientWidth
    })) : /*#__PURE__*/React.createElement(SingleTypeSelectMenu, _extends({}, props, {
      // TODO: Fix type
      // eslint-disable-next-line
      // @ts-ignore
      name: name,
      width: (_container$current2 = container.current) === null || _container$current2 === void 0 ? void 0 : _container$current2.clientWidth
    })));
  }, // eslint-disable-next-line
  [name, itemsHaveType]);
  return /*#__PURE__*/React.createElement("div", _extends({}, s('root'), getRootProps(), {
    "data-testid": "".concat(name, ".select"),
    ref: container
  }), /*#__PURE__*/React.createElement(BaseSelectInput, _extends({}, props, {
    name: name
  })), isOpen &&
  /*#__PURE__*/
  // TODO: Fix type
  // eslint-disable-next-line
  // @ts-ignore
  React.createElement(Tether, {
    distance: token('select.menu.distance', menuDistance),
    placement: 'bottom-start',
    Content: Content,
    Arrow: NullComponent,
    referenceElement: container === null || container === void 0 ? void 0 : container.current
  }));
}

function SingleSelect(props) {
  return /*#__PURE__*/React.createElement(BaseSelectCore, props, /*#__PURE__*/React.createElement(SingleSelectInner, props));
}

function MultiSelectInner(_ref3) {
  var _ref3$name = _ref3.name,
      name = _ref3$name === void 0 ? 'unknown' : _ref3$name,
      props = _objectWithoutProperties(_ref3, ["name"]);

  var s = useStyles(defaultStyles, 'MultiSelectInner');
  var token = useToken(); // we're using the the ref of the input container to measure the width we
  // want the tethered menu to have

  var container = useRef(null);

  var _useDownshiftContext3 = useDownshiftContext(),
      items = _useDownshiftContext3.items,
      getRootProps = _useDownshiftContext3.getRootProps,
      isOpen = _useDownshiftContext3.isOpen;

  var itemsHaveType = React.useMemo(function () {
    return _someInstanceProperty(items).call(items, function (item) {
      return item.type;
    });
  }, [items]);
  var Content = useCallback(function (contentProps) {
    var _container$current3, _container$current4;

    return /*#__PURE__*/React.createElement(TetherContent, contentProps, itemsHaveType ? /*#__PURE__*/React.createElement(MultiTypeSelectMenu, _extends({}, props, {
      // TODO: Fix type
      // eslint-disable-next-line
      // @ts-ignore
      name: name,
      width: (_container$current3 = container.current) === null || _container$current3 === void 0 ? void 0 : _container$current3.clientWidth
    })) : /*#__PURE__*/React.createElement(SingleTypeSelectMenu, _extends({}, props, {
      // TODO: Fix type
      // eslint-disable-next-line
      // @ts-ignore
      name: name,
      width: (_container$current4 = container.current) === null || _container$current4 === void 0 ? void 0 : _container$current4.clientWidth
    })));
  }, // eslint-disable-next-line
  [name, itemsHaveType]);
  return /*#__PURE__*/React.createElement("div", _extends({}, s('root'), getRootProps(), {
    "data-testid": "".concat(name, ".select"),
    ref: container
  }), /*#__PURE__*/React.createElement(BaseSelectInput, _extends({}, props, {
    name: name
  })), isOpen &&
  /*#__PURE__*/
  // TODO: Fix type
  // eslint-disable-next-line
  // @ts-ignore
  React.createElement(Tether, {
    distance: token('select.menu.distance', menuDistance),
    placement: 'bottom',
    Content: Content,
    Arrow: NullComponent,
    referenceElement: container === null || container === void 0 ? void 0 : container.current
  }));
}

function MultiSelect(props) {
  return /*#__PURE__*/React.createElement(BaseMultiSelectCore, props, /*#__PURE__*/React.createElement(MultiSelectInner, props));
}

var singleFilter = function singleFilter(items, inputValue) {
  return _filterInstanceProperty(items).call(items, function (item) {
    var _context;

    return _includesInstanceProperty(_context = get(item, 'label', '').toString().toLowerCase()).call(_context, inputValue.toLowerCase());
  });
};

var multiFilter = function multiFilter(items, inputValue, selectedItems) {
  var newItems = singleFilter(items, inputValue);
  return _filterInstanceProperty(newItems).call(newItems, function (item) {
    return !_findInstanceProperty(selectedItems).call(selectedItems, function (selectedItem) {
      return safeGetId(selectedItem) === safeGetId(item);
    });
  });
};

function BaseSelect(props) {
  var multi = props.multi,
      filter = _filterInstanceProperty(props),
      isFilterable = props.isFilterable;

  return /*#__PURE__*/React.createElement(StylesProvider, {
    components: overrides
  }, multi ? /*#__PURE__*/React.createElement(MultiSelect, _extends({}, props, {
    filter: isFilterable ? multiFilter : filter
  })) : /*#__PURE__*/React.createElement(SingleSelect, _extends({}, props, {
    filter: isFilterable ? singleFilter : filter
  })));
}

export { BaseSelect };